<template>
  <div>
    <d-row no-gutters>
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="auth-form__logo d-table mx-auto mb-3"
              src="@/assets/images/logos/logo-s.png"
              alt="Shards Dashboards - Forgot Password Template"
            />
            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">Redefinir sua senha</h5>
            <!-- Loader -->
            <div v-if="loading">
              <loader :is-loading="loading"></loader>
            </div>
            <div v-else>
              <!-- Form Fields -->
              <d-form>
                <ValidationObserver ref="validationForm">
                  <div class="form-group mb-4">
                    <ValidationProvider rules="required|email" v-slot="{errors, invalid}">
                      <d-input
                        :class="validatedForm | showValidateError(invalid)"
                        v-model="forgotPassword.Email"
                        type="email"
                        placeholder="E-mail"
                      />
                      <div class="invalid-feedback d-block" v-if="validatedForm">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <d-form-text
                      class="text-muted text-center"
                    >Você receberá por e-mail as instruções de redefinição.</d-form-text>
                  </div>
                  <button
                    v-on:click.stop="LostPasswordValidation($event)"
                    type="submit"
                    class="btn btn-pill btn-accent d-table mx-auto"
                  >REDEFINIR</button>
                </ValidationObserver>
              </d-form>
            </div>
          </d-card-body>
        </d-card>
        <!-- Meta -->
        <div class="auth-form__meta d-flex mt-4">
          <router-link class="mx-auto" :to="{ name: 'login' }">Voltar para o Login</router-link>
        </div>
      </d-col>
    </d-row>
  </div>
</template>

<script>
export default {
  name: "forgot-password",
  data: function() {
    return {
      loading: false,
      validatedForm: false,
      forgotPassword: {
        Email: null
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {
    LostPasswordValidation: function(e) {
      e.preventDefault();
      this.validatedForm = true;
      this.$refs.validationForm.validate().then(valid => {
        if (valid) {
          this.LostPassword();
        }
      });
    },
    LostPassword: function() {
      this.loading = true;
      this.$store
        .dispatch("LostPassword", { email: this.forgotPassword.Email })
        .then(() => {
          this.$makeToast(
            `Siga as instruções enviadas para o e-mail ${this.forgotPassword.Email} para redefinir sua senha.`,
            "success",
            "Redefinição de senha"
          );
          setTimeout(() => {
            this.$router.push({
              name: "login",
              query: {
                email: this.forgotPassword.Email
              }
            });
          }, 6000);
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao recuperar a senha",
            error
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/forgotPassword.vue